// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    margin: '20px 0',
    alignItems: 'center',
    width: '100%',
  },
  noReverse: {
    flexDirection: 'row',
    [theme.breakpoints.down(650)]: {
      flexDirection: 'column',
    },
  },
  reverse: {
    flexDirection: 'row-reverse',
    [theme.breakpoints.down(650)]: {
      flexDirection: 'column',
    },
  },
  title: {
    display: 'flex',
    color: GlobalStyles.color.COLOR_SECONDARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
  },
  description: {
    width: 'fit-content',
    display: 'flex',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    color: GlobalStyles.color.COLOR_GREY,
  },
  image: {
    height: 220,
    width: 300,
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 30px',
    maxWidth: 420,
    [theme.breakpoints.down(650)]: {
      alignItems: 'center',
      marginTop: 20,
    },
  },
  leftType: {
    alignSelf: 'flex-start',
    [theme.breakpoints.down(650)]: {
      alignSelf: 'center',
    },
  },
  rightType: {
    alignSelf: 'flex-end',
    [theme.breakpoints.down(650)]: {
      alignSelf: 'center',
    },
  }
});

export default styles;
